import axios from 'axios';

const API = axios.create({
 // baseURL: 'http://localhost:3000',
  baseURL: process.env.REACT_APP_API_URL, //for prod
  withCredentials: true, // if you use cookies/sessions
});

export default API;